// extracted by mini-css-extract-plugin
export default {"m":"_5992ff5ce6","title":"b21434b170","feedback_inner_title":"_4c38caff8f","textarea":"f83e149718","radio":"_2076b7a20d","text":"_5db62cd994"};